import React, { Component } from 'react';
import styled from 'styled-components';

import Button from './components/Button';
import Container from './components/Container';
import SectionHero from './components/SectionHero';

const SectionContent = styled.section`
  text-align: center;
  padding: 120px 0;
  .btn {
    margin: 45px auto 0;
  }
`;

class NotFound extends Component {
  componentDidMount() {
    document.title = "NSNorth 2019 | Page not found";
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <main className={`${ this.props.className }`}>
        <SectionHero bgVenue heading="Page not found" />
        <SectionContent>
          <Container>
            <p>Sorry, we are unable to find the page you are looking for.</p>
            <Button url="/" text="Go back to home" />
          </Container>
        </SectionContent>
      </main>
    );
  }
}

export default NotFound;